<template>
    <v-layout row wrap my-4>
        <v-flex v-for="(item, id) in content" :key="id" class="db-card md3 mb-4"
                :class="{'mr-0': $vuetify.breakpoint.xs, 'mr-4': $vuetify.breakpoint.smAndUp}"
                @click="modal_open_wrapper(item.database_id, item.databaseType)"
        >
            {{ item.name }}
        </v-flex>
    </v-layout>
</template>

<script>
import {mapGetters, mapMutations, mapActions} from 'vuex';
export default {
  components: {
  },
  props: {
    content: {
      type: Array,
    },
  },
  computed: {
    ...mapGetters('database/modal', [
      'database_detail_modal',
      'current_detail',
    ]),
  },
  methods: {
    ...mapMutations('database/modal', [
      'CLOSE_MODAL',
      'OPEN_MODAL',
      'SET_CURRENT',
    ]),
    modal_open_wrapper(database_id, type) {
      let obj = {type: type, id: database_id};
      this.SET_CURRENT(obj);
      this.OPEN_MODAL(this.database_detail_modal);
    //   this.SET_CURRENT(database_id);
    },
  },
};
</script>

